import React, { memo, useEffect, useRef, useState } from "react";
import Chart from "chart.js";
import "chartjs-plugin-labels";

const PC = function ({
  chartTitle,
  graphApiResponse = {},
  showPercentage,
  onEntityClick,
  entityList,
  isEmbededWidget,
}) {
  const chartContainer = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  const [chartData, setChartData] = useState({});
  const graphData = { ...graphApiResponse };
  const showLabels = graphData.labels && graphData.labels.length > 5;
  useEffect(() => {
    setChartData(graphData);
  }, [graphData && graphData.labels]);

  useEffect(() => {
    redrawChart(false);
  }, [chartData]);

  useEffect(() => {
    redrawChart(true);
  }, [showPercentage, showLabels]);

  const redrawChart = (forceRedraw) => {
    if (
      !chartContainer ||
      !chartContainer.current ||
      !Object.keys(chartData).length
    ) {
      return;
    }
    if (chartInstance && !forceRedraw) {
      chartInstance.data = chartData;
      chartInstance.update();
      return;
    }
    const ctx = chartContainer.current.getContext("2d");
    const chart = new Chart(ctx, {
      type: "pie",
      data: chartData,
      options: {
        plugins: {
          labels: {
            render: function ({ value, percentage, label }) {
              const renderValue = `${showLabels ? "" : `${label}-`} ${
                showPercentage ? `${percentage}%` : value
              }`;
              if (value / 100 <= 0.05) {
                return "";
              }
              return renderValue;
            },
            display: true,
            color: "red",
            position: showLabels ? "center" : "outside",
            outsidePadding: 8,
            textMargin: 6,
            textPadding: 10,
          },
        },
        events: ["click", "mousemove"],
        tooltips: {
          mode: "index",
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.labels[tooltipItem.index];
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const currentValue = dataset.data[tooltipItem.index];
              let faceValue = label;
              if (!showPercentage) {
                faceValue = ` ${label}: ${currentValue}`;
              } else {
                const total = dataset.data.reduce(function (
                  previousValue,
                  currentValue
                ) {
                  return (
                    parseInt(previousValue, 10) + parseInt(currentValue, 10)
                  );
                });
                const percentage = Math.floor(
                  (currentValue / total) * 100 + 0.5
                );
                faceValue = ` ${label}: ${percentage}%`;
              }
              return faceValue;
            },
          },
        },
        title: {
          display: !!chartTitle,
          text: chartTitle,
          margin: 10,
        },
        responsive: true,
        legend: {
          display: showLabels,
          labels: {
            boxWidth: 12,
          },
          maxHeight: 65,
        },
        exporting: {
          chartOptions: {
            legend: {
              enabled: true,
              verticalAlign: "bottom",
              maxHeight: 500,
              margin: 25,
            },
          },
        },
      },
    });
    setChartInstance(chart);
  };

  const handlePieClick = (e, { label }) => {
    if (!label) {
      return;
    }
    try {
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let entity =
        entityList &&
        entityList.filter(
          (elm) => label == elm.entity_display_name?.trim() || label == elm.name
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <React.Fragment key={showPercentage}>
      <div className={isEmbededWidget ? "biggerWidget" : ""}>
        <canvas
          onClick={(e) => {
            var activePoints = chartInstance.getElementsAtEvent(e);
            const clickedEntity =
              graphData.labels[activePoints[0] && activePoints[0]["_index"]];
            handlePieClick(e, { label: clickedEntity, lagend: "" });
          }}
          ref={chartContainer}
        ></canvas>
      </div>
    </React.Fragment>
  );
};

export const PieChart = memo(PC);
